import { render, staticRenderFns } from "./xhpzpopup.vue?vue&type=template&id=efa49380&scoped=true&"
import script from "./xhpzpopup.vue?vue&type=script&lang=js&"
export * from "./xhpzpopup.vue?vue&type=script&lang=js&"
import style0 from "./xhpzpopup.vue?vue&type=style&index=0&id=efa49380&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa49380",
  null
  
)

export default component.exports